(() => {
  const bind = (root = document) => {
    root.querySelectorAll('[data-pixel-product]').forEach((section) => {
      if (section.dataset.pixelBound) return;
      section.dataset.pixelBound = 'true';
      const image = section.querySelector('.pixel-product-main');
      const thumbnails = [...section.querySelectorAll('[data-pixel-image]')];
      const galleryControls = section.querySelector('[data-pixel-gallery-controls]');
      const galleryCount = section.querySelector('[data-pixel-gallery-count]');
      let galleryIndex = -1;
      const imageKey = (url) => {
        if (!url) return '';
        const parsed = new URL(url, document.baseURI);
        // Width transforms do not change which provider photograph is selected.
        parsed.searchParams.delete('width');
        return parsed.href;
      };
      const syncGallery = (url) => {
        const selectedKey = imageKey(url);
        galleryIndex = selectedKey ? thumbnails.findIndex(link => imageKey(link.dataset.pixelImage) === selectedKey) : -1;
        thumbnails.forEach((link, index) => {
          if (index === galleryIndex) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        const active = thumbnails[galleryIndex];
        const strip = active?.closest('.pixel-product-thumbs');
        if (strip) {
          const frame = strip.getBoundingClientRect();
          const selected = active.getBoundingClientRect();
          const left = frame.left + strip.clientLeft;
          const right = left + strip.clientWidth;
          const delta = selected.left < left ? selected.left - left
            : selected.right > right ? selected.right - right : 0;
          // Reveal the selected thumbnail inside its own strip without moving the page.
          if (delta) strip.scrollBy({ left: delta, behavior: 'auto' });
        }
        if (galleryCount) galleryCount.textContent = galleryIndex >= 0
          ? `Image ${galleryIndex + 1} of ${thumbnails.length}`
          : `Selected image · ${thumbnails.length} gallery images`;
      };
      const showImage = (url, alt, source) => {
        syncGallery(url);
        if (!image) return;
        image.removeAttribute('srcset');
        // Keep responsive selection after thumbnails and variants change the image.
        if (url) {
          const imageUrl = new URL(url, document.baseURI);
          const sameImageHost = imageUrl.hostname === location.hostname || imageUrl.hostname === 'cdn.shopify.com' || imageUrl.hostname.endsWith('.shopifycdn.com') || imageUrl.hostname.endsWith('.shopifycdn.net');
          if (sameImageHost && ['https:', 'http:'].includes(imageUrl.protocol)) {
            const sourceWidth = Number(source?.dataset.pixelWidth) || 1600;
            const widths = [...new Set([320, 480, 640, 960, 1280, 1600].map(width => Math.min(width, sourceWidth)))];
            image.srcset = widths.map(width => {
              const candidate = new URL(imageUrl);
              candidate.searchParams.set('width', String(width));
              return `${candidate.href} ${width}w`;
            }).join(', ');
          }
          const width = Number(source?.dataset.pixelWidth);
          const height = Number(source?.dataset.pixelHeight);
          if (width > 0 && height > 0) { image.width = width; image.height = height; }
        }
        image.hidden = !url;
        const wrap = image.closest('.pixel-editorial-image-wrap');
        if (wrap) wrap.hidden = !url;
        if (url) image.src = url;
        else image.removeAttribute('src');
        image.alt = alt || '';
        const opener = section.querySelector('[data-pixel-editorial-open]');
        if (opener && url) opener.href = url;
        const status = section.querySelector('[data-pixel-image-status]');
        if (status) status.hidden = true;
      };
      section.querySelectorAll('[data-pixel-image]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          showImage(link.dataset.pixelImage, link.dataset.pixelAlt, link);
        });
      });
      if (image) {
        const status = section.querySelector('[data-pixel-image-status]');
        image.addEventListener('error', () => { if (status) status.hidden = false; });
        image.addEventListener('load', () => { if (status) status.hidden = true; });
      }
      syncGallery(image?.getAttribute('src'));
      if (galleryControls && image && thumbnails.length > 1) {
        galleryControls.querySelectorAll('[data-pixel-gallery-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const direction = Number(button.dataset.pixelGalleryDirection);
            const next = galleryIndex < 0 ? (direction > 0 ? 0 : thumbnails.length - 1)
              : (galleryIndex + direction + thumbnails.length) % thumbnails.length;
            thumbnails[next].click();
          });
        });
        galleryControls.hidden = false;
      }
      thumbnails.forEach((link, index) => link.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % thumbnails.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + thumbnails.length) % thumbnails.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = thumbnails.length - 1;
        else return;
        event.preventDefault();
        thumbnails[next].focus({ preventScroll: true });
        thumbnails[next].click();
      }));
      const select = section.querySelector('[data-pixel-variant]');
      const quantity = section.querySelector('[data-pixel-quantity]');
      const price = section.querySelector('[data-pixel-price]');
      const add = section.querySelector('[data-pixel-add]');
      const status = section.querySelector('[data-pixel-availability]');
      if (!select) return;
      const fallback = section.querySelector('[data-pixel-variant-fallback]');
      if (fallback) select.value = fallback.value;
      // URL and head metadata belong only to the current product's single main section.
      const isCurrentProduct = () => {
        let productUrl;
        try { productUrl = new URL(section.dataset.pixelProductUrl); } catch { return false; }
        return productUrl && productUrl.origin === location.origin && productUrl.pathname === location.pathname &&
          section.closest('main') && document.querySelectorAll('main [data-pixel-product]').length === 1 &&
          section.dataset.productKind !== 'inquiry';
      };
      const syncMetadata = (option, available) => {
        try {
          if (!isCurrentProduct()) return;
          const productUrl = new URL(section.dataset.pixelProductUrl);
          const rawPrice = Number(option.dataset.rawPrice);
          const currency = option.dataset.currency;
          if (!option.dataset.rawPrice || !Number.isFinite(rawPrice) || rawPrice < 0 || !currency) return;
          productUrl.search = '';
          productUrl.hash = '';
          const variantUrl = new URL(productUrl);
          variantUrl.searchParams.set('variant', option.value);
          const schemaImage = option.dataset.schemaImage || '';
          const schemaNode = section.previousElementSibling;
          if (schemaNode?.matches('script[data-pixel-product-schema]')) {
            const schema = JSON.parse(schemaNode.textContent);
            // Never manufacture an Offer for an inquiry or unrelated schema.
            if (schema['@type'] === 'Product' && schema.url === productUrl.href && schema.offers?.['@type'] === 'Offer') {
              schema.offers.url = variantUrl.href;
              schema.offers.price = rawPrice;
              schema.offers.priceCurrency = currency;
              schema.offers.availability = `https://schema.org/${available ? 'InStock' : 'OutOfStock'}`;
              if (schemaImage) schema.image = schemaImage;
              else delete schema.image;
              if (option.dataset.sku) schema.sku = option.dataset.sku;
              else delete schema.sku;
              schemaNode.textContent = JSON.stringify(schema).replace(/<\//g, '<\\/');
            }
          }
          const setMeta = (property, value) => {
            let node = document.head.querySelector(`meta[data-pixel-meta][property="${property}"]`);
            if (!value) { node?.remove(); return; }
            // Do not overwrite metadata supplied by an app or another theme component.
            if (!node && document.head.querySelector(`meta[property="${property}"]`)) return;
            if (!node) {
              node = document.createElement('meta');
              node.setAttribute('property', property);
              node.setAttribute('data-pixel-meta', '');
              document.head.append(node);
            }
            node.content = value;
          };
          setMeta('og:price:amount', String(rawPrice));
          setMeta('og:price:currency', currency);
          setMeta('og:image', schemaImage);
          setMeta('og:image:secure_url', schemaImage);
          // The selected image can have different dimensions from the initial page_image.
          setMeta('og:image:width', '');
          setMeta('og:image:height', '');
        } catch (error) {
          // Metadata must never interrupt native variant/form ownership initialization.
          console.warn('Pixel variant metadata could not be synchronized:', error.message);
        }
      };
      const syncVariant = () => {
        const option = select.selectedOptions[0];
        if (!option) return false;
        if (price) price.textContent = option.dataset.price;
        const available = option.dataset.available === 'true';
        if (add) { add.disabled = !available; add.textContent = available ? 'Add to bag' : 'Sold out'; }
        if (status) status.textContent = available ? 'Available to add to your bag.' : 'This option is currently sold out.';
        if (quantity) {
          quantity.min = option.dataset.min;
          quantity.step = option.dataset.step;
          if (option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
          const requested = Number(quantity.value);
          const minimum = Number(quantity.min);
          const increment = Number(quantity.step);
          const maximum = quantity.max ? Number(quantity.max) : Infinity;
          const remainsValid = quantity.value !== '' && Number.isSafeInteger(requested)
            && requested >= minimum && requested <= maximum
            && Number.isSafeInteger(increment) && increment > 0
            && (requested - minimum) % increment === 0;
          if (!remainsValid) quantity.value = option.dataset.min;
        }
        showImage(option.dataset.image, option.dataset.alt, option);
        if (isCurrentProduct()) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState(null, '', url);
          syncMetadata(option, available);
        }
        return true;
      };
      select.addEventListener('change', syncVariant);
      // Keep the server-rendered ID active unless initialization completes.
      if (!syncVariant()) return;
      if (fallback) fallback.disabled = true;
      select.disabled = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind());
  else bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
